import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DayProps } from "../Day";
import { ConsultationTogglerContainer } from "./StyledElements";
import { useDispatch, useSelector } from "../../../../store/store";
import {
    addConsultation,
    isDayDisabled,
    removeConsultation,
} from "../../../../store/data";
import {useTranslation} from "react-i18next";

interface Props {
    day: DayProps;
    consultationIndex: number;
    toggleType: "add" | "remove";
    additional: boolean;
}

const ToggleConsultation = ({
    day,
    toggleType,
    consultationIndex,
    additional,
}: Props) => {
    const dispatch = useDispatch();
    const dayDisabled = useSelector(isDayDisabled(day));
    const { t } = useTranslation();

    const handleClick = () => {
        dispatch(
            toggleType === "add"
                ? addConsultation(day)
                : removeConsultation({ day, consultationIndex })
        );
    };

    return (
        <ConsultationTogglerContainer
            additional={additional}
            disabled={dayDisabled}
            onClick={handleClick}
        >
            {toggleType === "add" ? (
                `+ ${t('consultation_time').toUpperCase()}`) 
                 : (
                <FontAwesomeIcon className="fas" icon={faTrashAlt} />
            )}
        </ConsultationTogglerContainer>
    );
};

export default ToggleConsultation;
